<template>
  <ol class="Timeline">
    <slot></slot>
  </ol>
</template>

<script lang="ts" setup>

</script>

<style lang="scss">
.Timeline {
  border-inline-start: $blackBorder solid 1px;
  list-style-type: none;
  margin-inline-start: 0.5rem;
}
</style>
